import React from "react";
import { Card, CardHeader, Divider } from "@mui/material";

export default function SectionCard({ title, children, subtitle, action, sx, headerSx, titleTypographyProps, divider = true, ...props }) {
  return (
    <Card variant="outlined" sx={{ mb: 3, ...sx }} {...props}>
      <CardHeader title={title} subheader={subtitle} action={action} sx={headerSx} titleTypographyProps={titleTypographyProps} />
      {divider && <Divider />}
      {children}
    </Card>
  );
}
